export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 20\"><path d=\"M28.5,11.5H1.5a1.5,1.5,0,0,1,0-3h27a1.5,1.5,0,0,1,0,3Z\"/></svg>";